import { useEffect } from 'react';
import { useGetCurrentPractitioner } from '../settings';
import { useAuth } from '@frontegg/react';

export const useCello = () => {
  const { user } = useAuth();
  const { data: currentPractitioner } = useGetCurrentPractitioner();

  const celloToken = currentPractitioner?.cello_token;
  useEffect(() => {
    window.cello = window.cello || { cmd: [] };
    if (celloToken && user && !window.cello.cmd.length) {
      window.cello.cmd.push(async function (cello) {
        try {
          await cello.boot({
            productId: import.meta.env.VITE_CELLO_PRODUCT_ID,
            token: celloToken,
            language: 'en',
            productUserDetails: {
              firstName: currentPractitioner.practitioner_first_name,
              lastName: currentPractitioner.practitioner_last_name,
              fullName: currentPractitioner.practitioner_name,
              email: user.email,
            },
          });
        } catch (error) {
          console.error('Failed to boot cello:', error);
        }
      });
    }
  }, [currentPractitioner, user]);

  return {
    token: celloToken,
  };
};
